import type React from "react";

import { Box, Typography } from "@mui/material";
import styled from "styled-components";

interface PreviewContainerProps {
  children: React.ReactNode;
  showBoxShadow?: boolean;
  title: string;
  topContent?: React.ReactNode;
}

export const PreviewContainer: React.FC<PreviewContainerProps> = ({ children, showBoxShadow, title, topContent }) => {
  return (
    <Container $boxShadow={showBoxShadow}>
      <Box display="flex" alignItems="center" mb={3} justifyContent="space-between">
        <Typography variant="h3">{title}</Typography>

        {topContent && <div>{topContent}</div>}
      </Box>

      {children}
    </Container>
  );
};

export const Container = styled.div<{ $boxShadow?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 12px;
  box-shadow: ${({ $boxShadow }) => ($boxShadow ? "0px 2px 4px 0px rgba(0, 0, 0, 0.05)" : "none")};

  ${props => props.theme.aboveBreakpoint} {
    padding: 24px;
  }
`;
